import React, { Fragment, useCallback, useMemo } from "react";
import * as S from "./BrandPrinciplesHero.styles";
import { IHeroSection } from "./BrandPrinciplesHero.types";
import { ProgressAnimationButton } from "components/ProgressAnimationButton";
import { useTranslation } from "hooks/useTranslation";

export const BrandPrinciplesHeroTabs = ({
  slides,
  videoPlaybackTime,
  activeTab,
  isInView,
  onHandleTabClick,
}: Readonly<{
  slides: Array<IHeroSection>;
  activeTab: IHeroSection;
  isInView?: boolean;
  videoPlaybackTime: Record<string | number, number>;
  onHandleTabClick: (tab: IHeroSection) => void;
}>) => {
  const { t } = useTranslation();

  const playbackTime = useMemo(() => {
    return videoPlaybackTime[activeTab.id];
  }, [activeTab.id, videoPlaybackTime]);

  const isActive = useCallback(
    (tab: IHeroSection) => {
      return isInView && tab.id === activeTab.id && !!playbackTime;
    },
    [isInView, activeTab.id, playbackTime],
  );

  return (
    <Fragment>
      {slides.map((tab, index) => (
        <Fragment key={`${tab.label}-${index}`}>
          <S.StatusBarContainer onClick={() => onHandleTabClick(tab)}>
            <S.StyledStatusBar
              $isActive={isActive(tab)}
              $playbackLimit={playbackTime ?? 0}
            />
          </S.StatusBarContainer>

          <S.ButtonWrapper>
            <ProgressAnimationButton
              isActive={activeTab?.id === tab.id}
              canPlayAnimation={isActive(tab)}
              playbackTimeInSeconds={videoPlaybackTime[tab.id] ?? 0}
              text={t(tab.label)}
              handleClick={() => onHandleTabClick(tab)}
            />
          </S.ButtonWrapper>
        </Fragment>
      ))}
    </Fragment>
  );
};
